import React, { Fragment, useState, useEffect } from "react";
import SideMenu from "../../Components/SideMenu";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import swal from 'sweetalert';
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import ApiSetting from "../../../../../Settings/ApiSettings.json";
import Styles from "../../../../Slices/Mof/Styles.json";
import "../../Dashboard.css";
import axios from "axios";
import AddCircleSharpIcon from "@mui/icons-material/AddCircleSharp";
import RemoveCircleSharpIcon from "@mui/icons-material/RemoveCircleSharp";
import { useGlobalContext } from "../../../../../context";
import format from "date-fns/format";
import { SnackbarProvider, useSnackbar } from "notistack";
import calculateAge from "calculate-age";
import DeleteSharpIcon from '@mui/icons-material/DeleteSharp';
import Cookies from "universal-cookie";
const cookies = new Cookies();

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const label = { inputProps: { "aria-label": "توقيع المكلف او وكيله" } };

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function IncomeTaxReport(props) {
  // const { enqueueSnackbar } = useSnackbar();
  const [IPaddress, setIPaddress] = useState("");
  const [inactive, setInactive] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackBar, setsnackBar] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "center",
    message: "",
    severity: "",
  });

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  //basic information hooks...
  const [folderNumber, setFolderNumber] = useState(null);
  const [gender, setGender] = useState(0);
  const [taxPayerName, setTaxPayerName] = useState({
    first: "",
    second: "",
    third: "",
    fourth: "",
    title: "",
  });
  const [motherName, setMotherName] = useState("");
  const [nationality, setNationality] = useState("عراقية");
  const [birthDate, setBirthDate] = useState(null);

  // civil status card hooks...
  const [civilStatusCardRecord, setCivilStatusCardRecord] = useState(null);
  const [civilStatusCardPage, setCivilStatusCardPage] = useState(null);
  const [civilStatusCardNumber, setCivilStatusCardNumber] = useState(null);

  // home address hooks...
  const [homeAddressGovernorate, setHomeAddressGovernorate] = useState("");
  const [homeAddressDistrict, setHomeAddressDistrict] = useState("");
  const [homeAddressTownship, setHomeAddressTownship] = useState("");
  const [homeAddressVillage, sethomeAddressVillage] = useState("");
  const [homeAddressNumber, setHomeAddressNumber] = useState(null);
  const [homeAddressNeighborhood, setHomeAddressNeighborhood] = useState(null);
  const [homeAddressLocality, setHomeAddressLocality] = useState(null);
  const [homeAddressAlley, setHomeAddressAlley] = useState(null);
  const [homeAddressHouse, setHomeAddressHouse] = useState(null);

  const [listOfMessage, setListOfMessage] = useState({
    folderNumber: "",
    name: {
      first: "",
      second: "",
      third: "",
      forth: "",
      title: "",
    },
    motherName: "",
    birthDate: "",
    civilStatusCard: {
      folderNumber: "",
      page: "",
      number: "",
    },
    HomeAddress: {
      governoarte: "",
      distric: "",
      twonShip: "",
      valliage: "",
      number: "",
      neighborhood: "",
      locality: "",
      alley: "",
      house: "",
    },
    careerInfo: {
      group: "",
      careerName: "",
      tradeName: "",
      addressOfWork: "",
      estimation: "",
    },
    phones: {
      p_work: "",
      p_home: "",
    },
    maritalStatus: {
      status: "",
      number: "",
    },
    wifrOrhusbandInfo: {
      name: {
        first: "",
        second: "",
        third: "",
        forth: "",
        title: "",
      },
      career: "",
      folderNumber: "",
      branch: "",
    },
    agency: {
      number: "",
      date: "",
      issuer: "",
    },
    children: {
      name: "",
      date: "",
      gender: "",
      number: "",
      dateOfCivilStatusCard: "",
    },
  });
  //year
  const [year, setYear] = useState(format(new Date(), "yyyy"));

  // career info hooks ...
  const [career, setCareer] = useState("");
  const [tradeName, setTradeName] = useState("");
  const [addressOfWork, setAddressOfWork] = useState("");
  const [estimateIncomeFromAllResources, setEstimateIncomeFromAllResources] =
    useState("");
  const [hasJob, setHasJob] = useState(0);
  const [selectedGroupOfCareers, setSelectedGroupOfCareers] = useState("");

  //phone numbers hooks...
  const [phoneNumberOfWork, setPhoneNumberOfWork] = useState(null);
  const [phoneNumberOfHome, setPhoneNumberOfHome] = useState(null);

  //marital status hooks ...
  const [maritalStatus, setMaritalStatus] = useState("");
  const [numberOfWives, setNumberOfWives] = useState(null);
  const [wifeOrHusbandName, setWifeOrHusbandName] = useState({
    first: "",
    second: "",
    third: "",
    fourth: "",
    title: "",
  });
  const [wifeOrHusbandCareer, setWifeOrHusbandCareer] = useState("");
  const [wifeOrHusbandFolderNumber, setWifeOrHusbandFolderNumber] =
    useState(null);
  const [wifeOrHusbandBranch, setWifeOrHusbandBranch] = useState("");
  const [WifeOrHusbandHasJob, setWifeOrHusbandHasJob] = useState(0);

  // taxpayer and speculative signature hooks...
  const [signatureOfTaxPayer, setsignatureOfTaxPayer] = useState(0);
  const [signatureOfTaxPayerDate, setSignatureOfTaxPayerDate] = useState(
    new Date()
  );
  const [agencyNo, setAgencyNo] = useState(null);
  const [agencyNoDate, setAgencyNoDate] = useState(new Date());
  const [issuer, setIssuer] = useState("");
  const [nameOfSpeculativeUnitWriter, setNameOfSpeculativeUnitWriter] =
    useState("");
  const [
    signatureOfSpeculativeUnitWriter,
    setSignatureOfSpeculativeUnitWriter,
  ] = useState(0);

  //images hooks...
  const [imageFiles, setImageFiles] = useState([]);
  const [fileType, setFileType] = useState("");
  const [ImageForWhat, setImageForWhat] = useState("");
  const [imageMemies, setImageMemies] = useState(
    "image/x-png,image/jpg,image/jpeg"
  );
  const [countImage, setCountImage] = useState([]);
  const [getIndexOfImageForWhate, setgetIndexOfImageForWhate] = useState([]);

  //children hooks ...
  const [childrenObj, setChildrenObj] = useState([]);

  // error hooks here...
  const [messageErrors, setMessageErrors] = useState([]);

  const [careersForGroupSelected, setCareersForGroupSelected] = useState([]);

  const {
    // loading,
    // incomeResourceValues,
    GroupsOfCareers,
    SPECIFIC_CAREER_FOR_GROUP,
    // interestReasonValues,
    // fineReasonValues,
    // discountReasonValues,
    // permitReasonValues,
    fetchData,
  } = useGlobalContext();

  // get related carriers for each group you selected.
  const getSpecificCareersForGrou = async (groupName) => {
    setSelectedGroupOfCareers(groupName);
    let data = null;
    try {
      data = await axios({
        method: "post",
        url: IPaddress + "/GroupsCarrier/getRelatedCarriers",
        data: {
          GroupsCarriersID: groupName,
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (data) {
        if (data.data.status == 200) {
          setCareersForGroupSelected(data.data.data);
          if (data.data.data.length == 0) {
            setsnackBar({
              ...snackBar,
              message: "لا توجد بيانات لهذه المجموعة",
              severity: "warning",
              open: true,
            });
          }
        } else {
          setsnackBar({
            ...snackBar,
            message: data.data.message,
            severity: "warning",
            open: true,
          });
        }
      }
    } catch (err) {
      setsnackBar({
        ...snackBar,
        message: err.message,
        severity: "error",
        open: true,
      });
    }
  };

  useEffect(() => {
    fetchData("GROUP_OF_CAREER", "GroupsCarrier/show", {});
    setIPaddress(ApiSetting.apiUrl);
    if (!cookies.get("role_id")) {
      window.location.href = "/";
    }
  }, []);

  useEffect(() => {
    console.log(GroupsOfCareers);
  }, [GroupsOfCareers]);
  //sent data of form...
  const sentDateOfForm = async () => {
    setMessageErrors([]);
    let dataForm = new FormData();

    if(folderNumber)
    dataForm.append("folder_number", folderNumber);

    dataForm.append("year", year);
    dataForm.append("gender", gender);

    dataForm.append(
      "tax_payer_name",
      taxPayerName.first +
        " " +
        taxPayerName.second +
        " " +
        taxPayerName.third +
        " " +
        taxPayerName.fourth +
        " " +
        taxPayerName.title
    );
    dataForm.append("mother_name", motherName);
    dataForm.append("nationality", nationality);
    if (birthDate) dataForm.append("birth_date", formatDate(birthDate));

    dataForm.append("civil_status_card_record", civilStatusCardRecord);
    dataForm.append("civil_status_card_page", civilStatusCardPage);
    dataForm.append("civil_status_card_number", civilStatusCardNumber);

    dataForm.append("home_address_governorate", homeAddressGovernorate);
    if(homeAddressDistrict)
    dataForm.append("home_address_district", homeAddressDistrict);
    if(homeAddressTownship)
    dataForm.append("home_address_township", homeAddressTownship);
    if(homeAddressVillage)
    dataForm.append("home_address_village", homeAddressVillage);
    if(homeAddressNumber)
    dataForm.append("home_address_number", homeAddressNumber);
    if(homeAddressNeighborhood)
    dataForm.append("home_address_Neighborhood", homeAddressNeighborhood);
    if(homeAddressLocality)
    dataForm.append("home_address_locality", homeAddressLocality);
    if(homeAddressAlley)
    dataForm.append("home_address_alley", homeAddressAlley);
    if(homeAddressHouse)
    dataForm.append("home_address_house", homeAddressHouse);

    dataForm.append("career", career);
    dataForm.append("Group_of_careers", selectedGroupOfCareers);
    dataForm.append("has_job", hasJob); //0 no job //1 has job
    dataForm.append("trade_name", tradeName);
    dataForm.append(
      "estimate_income_from_all_resources",
      estimateIncomeFromAllResources
    );
    dataForm.append("address_of_work", addressOfWork);
    dataForm.append("phone_number_work", phoneNumberOfWork);
    dataForm.append("phone_number_home", phoneNumberOfHome);

    dataForm.append("marital_status", maritalStatus);
    dataForm.append("number_of_wives", numberOfWives);
    
    dataForm.append(
      "wife_or_husband_name",
      wifeOrHusbandName.first +
        " " +
        wifeOrHusbandName.second +
        " " +
        wifeOrHusbandName.third +
        " " +
        wifeOrHusbandName.fourth +
        " " +
        wifeOrHusbandName.title
    );
    if(wifeOrHusbandCareer)
    dataForm.append("wife_or_husband_career", wifeOrHusbandCareer);
    else if(WifeOrHusbandHasJob==1){
      swal("تحذير!", "يجب اختيار المهنة الخاصة بالزوج او الزوجة!", "error");
      return;
    }
    dataForm.append("wife_or_husband_has_job", WifeOrHusbandHasJob); //0 no job //1 has job
    if (wifeOrHusbandFolderNumber)
      dataForm.append(
        "wife_or_husband_folder_number",
        wifeOrHusbandFolderNumber
      );
    if(wifeOrHusbandBranch)
    dataForm.append("wife_or_husband_branch", wifeOrHusbandBranch);
    if(signatureOfTaxPayer)
    dataForm.append("signature_of_tax_payer", signatureOfTaxPayer);
    if(signatureOfTaxPayerDate)
    dataForm.append(
      "signature_of_tax_payer_date",
      formatDate(signatureOfTaxPayerDate)
    );
    if(agencyNo)
    dataForm.append("agency_no", agencyNo);
    if(agencyNoDate)
    dataForm.append("agency_no_date", formatDate(agencyNoDate));
    if(issuer)
    dataForm.append("issuer", issuer);
    if(nameOfSpeculativeUnitWriter)
    dataForm.append(
      "name_of_speculative_unit_writer",
      nameOfSpeculativeUnitWriter
    );
    else if(cookies.get('role_id') == 5) {
      swal("تحذير!", "اسم كاتب الوحدة التخمينية مطلوب!", "error");
       return;
    }
    if(signatureOfSpeculativeUnitWriter==0||
       signatureOfSpeculativeUnitWriter==1)
    dataForm.append(
      "signature_of_speculative_unit_writer",
      signatureOfSpeculativeUnitWriter
    );
    // else if(cookies.get('role_id') == 5) {
    //   swal("تحذير!", "موافقة كاتب الوحدة التخمينية مطلوبة!", "error");
    //   return
    // }
    // resources files...
    if (countImage.length > 0)
      countImage.map((image, index) => {
        if (image.file) dataForm.append(`images[${index}][file]`, image.file);
        dataForm.append(`images[${index}][file_type]`, image.fileType);
        dataForm.append(`images[${index}][image_for_what]`, image.ImageForWhat);
        // dataForm.append("images[][image_for_what]", image.ImageForWhat);
      });
    // children ...
    if (childrenObj.length > 0) {
      childrenObj.map((data, index) => {
        dataForm.append(`children[${index}][name]`, data.name);
        dataForm.append(
          `children[${index}][birth_date]`,
          formatDate(data.birthDate)
        );
        dataForm.append(
          `children[${index}][civil_card_status_number]`,
          data.civilStatusCardNumber
        );
        dataForm.append(
          `children[${index}][civil_card_status_date]`,
          formatDate(data.civilStatusCardDate)
        );
        dataForm.append(`children[${index}][gender]`, data.gender);
        dataForm.append(`children[${index}][is_married]`, data.isMarried);
      });
    }
    // console.log(countImage);
    // dataForm.append("images[]", JSON.stringify(countImage));
    setLoading(true);

    let data = null;
    try {
      data = await axios({
        method: "post",
        url: IPaddress + "/income_tax_report/insert",
        data: dataForm,
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      });
      // console.log("data", data);
      if (data) {
        if (data.data.status == 200) {
          window.scrollTo(0, 0);
          restAllStatesOfForm();
          setsnackBar({
            ...snackBar,
            open: true,
            severity: "success",
            message: data.data.message,
          });
        } else if (data.data.status == 500) {
          if (data.data.data) {
            if (data.data.data.folder_number) {
              setMessageErrors((err) => [
                ...err,
                {
                  folderNumber: data.data.data.folder_number,
                },
              ]);
            }
            if (data.data.data.year) {
              setMessageErrors((err) => [
                ...err,
                {
                  year: data.data.data.year,
                },
              ]);
            }
            if (data.data.data.gender) {
              setMessageErrors((err) => [
                ...err,
                { gender: data.data.data.gender },
              ]);
            }

            if (data.data.data.tax_payer_name)
              setMessageErrors((err) => [
                ...err,
                {
                  taxPayerName: data.data.data.tax_payer_name,
                },
              ]);

            if (data.data.data.mother_name)
              setMessageErrors((err) => [
                ...err,
                { motherName: data.data.data.mother_name },
              ]);

            if (data.data.data.nationality)
              setMessageErrors((err) => [
                ...err,
                { nationality: data.data.data.nationality },
              ]);

            if (data.data.data.birth_date)
              setMessageErrors((err) => [
                ...err,
                { birthDate: data.data.data.birth_date },
              ]);

            if (data.data.data.civil_status_card_record)
              setMessageErrors((err) => [
                ...err,
                {
                  civilStatusCardRecord:
                    data.data.data.civil_status_card_record,
                },
              ]);

            if (data.data.data.civil_status_card_page)
              setMessageErrors((err) => [
                ...err,
                {
                  civilStatusCardPage: data.data.data.civil_status_card_page,
                },
              ]);

            if (data.data.data.civil_status_card_number)
              setMessageErrors((err) => [
                ...err,
                {
                  civilStatusCardNumber:
                    data.data.data.civil_status_card_number,
                },
              ]);

            if (data.data.data.home_address_governorate)
              setMessageErrors((err) => [
                ...err,
                {
                  homeAddressGoverNorate:
                    data.data.data.home_address_governorate,
                },
              ]);

            if (data.data.data.home_address_district)
              setMessageErrors((err) => [
                ...err,
                {
                  homeAddressDistrict: data.data.data.home_address_district,
                },
              ]);
            if (data.data.data.home_address_township)
              setMessageErrors((err) => [
                ...err,
                {
                  homeAddressTownship: data.data.data.home_address_township,
                },
              ]);
            if (data.data.data.home_address_village)
              setMessageErrors((err) => [
                ...err,
                {
                  homeAddressVillage: data.data.data.home_address_village,
                },
              ]);
            if (data.data.data.home_address_number)
              setMessageErrors((err) => [
                ...err,
                {
                  homeAddressNumber: data.data.data.home_address_number,
                },
              ]);
            if (data.data.data.home_address_Neighborhood)
              setMessageErrors((err) => [
                ...err,
                {
                  homeAddressNeighborhood:
                    data.data.data.home_address_Neighborhood,
                },
              ]);
            if (data.data.data.home_address_locality)
              setMessageErrors((err) => [
                ...err,
                {
                  homeAddressLocality: data.data.data.home_address_locality,
                },
              ]);
            if (data.data.data.home_address_alley)
              setMessageErrors((err) => [
                ...err,
                {
                  homeAddressAlley: data.data.data.home_address_alley,
                },
              ]);
            if (data.data.data.home_address_house)
              setMessageErrors((err) => [
                ...err,
                {
                  homeAddressHouse: data.data.data.home_address_house,
                },
              ]);
            if (data.data.data.estimate_income_from_all_resources)
              setMessageErrors((err) => [
                ...err,
                {
                  estimateIncomeFromAllResources:
                    data.data.data.estimate_income_from_all_resources,
                },
              ]);
            if (data.data.data.number_of_wives)
              setMessageErrors((err) => [
                ...err,
                {
                  numberOfWives: data.data.data.number_of_wives,
                },
              ]);
            if (data.data.data.wife_or_husband_name)
              setMessageErrors((err) => [
                ...err,
                {
                  wifeOrHusbandName: data.data.data.wife_or_husband_name,
                },
              ]);
            if (data.data.data.wife_or_husband_career)
              setMessageErrors((err) => [
                ...err,
                {
                  wifeOrHusbandCareer: data.data.data.wife_or_husband_career,
                },
              ]);
            if (data.data.data.wife_or_husband_folder_number)
              setMessageErrors((err) => [
                ...err,
                {
                  wifeOrHusbandFolderNumber:
                    data.data.data.wife_or_husband_folder_number,
                },
              ]);
            if (data.data.data.wife_or_husband_branch)
              setMessageErrors((err) => [
                ...err,
                {
                  wifeOrHusbandBranch: data.data.data.wife_or_husband_branch,
                },
              ]);

            if (data.data.data.career)
              setMessageErrors((err) => [
                ...err,
                { career: data.data.data.career },
              ]);

            if (data.data.data.address_of_work)
              setMessageErrors((err) => [
                ...err,
                {
                  addressOfWork: data.data.data.address_of_work,
                },
              ]);

            if (data.data.data.phone_number_work)
              setMessageErrors((err) => [
                ...err,
                {
                  phoneNumberWork: data.data.data.phone_number_work,
                },
              ]);

            if (data.data.data.phone_number_home)
              setMessageErrors((err) => [
                ...err,
                {
                  phoneNumberHome: data.data.data.phone_number_home,
                },
              ]);

            if (data.data.data.marital_status)
              setMessageErrors((err) => [
                ...err,
                {
                  maritalStatus: data.data.data.marital_status,
                },
              ]);

            if (data.data.data.signature_of_tax_payer)
              setMessageErrors((err) => [
                ...err,
                {
                  signatureOfTaxPayer: data.data.data.signature_of_tax_payer,
                },
              ]);

            if (data.data.data.signature_of_tax_payer_date)
              setMessageErrors((err) => [
                ...err,
                {
                  signatureOfTaxPayerDate:
                    data.data.data.signature_of_tax_payer_date,
                },
              ]);

            if (data.data.data.agency_no)
              setMessageErrors((err) => [
                ...err,
                {
                  agencyNo: data.data.data.agency_no,
                },
              ]);

            if (data.data.data.agency_no_date)
              setMessageErrors((err) => [
                ...err,
                {
                  agencyNoDate: data.data.data.agency_no_date,
                },
              ]);

            if (data.data.data.issuer)
              setMessageErrors((err) => [
                ...err,
                {
                  issuer: data.data.data.issuer,
                },
              ]);

            if (data.data.data.name_of_speculative_unit_writer)
              setMessageErrors((err) => [
                ...err,
                {
                  nameOfSpeculativeUnitWriter:
                    data.data.data.name_of_speculative_unit_writer,
                },
              ]);

            if (data.data.data.signature_of_speculative_unit_writer)
              setMessageErrors((err) => [
                ...err,
                {
                  signatureOfSpeculativeUnitWriter:
                    data.data.data.signature_of_speculative_unit_writer,
                },
              ]);
          }

          setsnackBar({
            ...snackBar,
            open: true,
            severity: "warning",
            message: data.data.message,
          });
        } else {
          setsnackBar({
            ...snackBar,
            open: true,
            severity: "warning",
            message: data.data.message,
          });
        }
      }
      setLoading(false);
    } catch (err) {
      console.log("data", data);
      setsnackBar({
        ...snackBar,
        open: true,
        severity: "error",
        message: err.message,
      });
      setLoading(false);
    }
  };
  const [countFileNotExists, setcountFileNotExists] = useState(0);
  const restAllStatesOfForm=()=>{
    setFolderNumber(null);
    setGender(0);
    setTaxPayerName({
      first: "",
      second: "",
      third: "",
      fourth: "",
      title: "",
    });

    setMotherName('')
    setNationality('عراقية')
    setBirthDate(new Date())
    setCivilStatusCardRecord(null)
    setCivilStatusCardPage(null)
    setCivilStatusCardNumber(null)

     setHomeAddressGovernorate("");
     setHomeAddressDistrict("");
     setHomeAddressTownship("");
     sethomeAddressVillage("");
     setHomeAddressNumber(null);
     setHomeAddressNeighborhood(null);
     setHomeAddressLocality(null);
     setHomeAddressAlley(null);
     setHomeAddressHouse(null);

     setYear(format(new Date(), "yyyy"))
     setCareer('')
     setTradeName('')
     setAddressOfWork("")
     setEstimateIncomeFromAllResources('')
     setHasJob(0)
     setSelectedGroupOfCareers('')

     setPhoneNumberOfHome(null)
     setPhoneNumberOfWork(null)


     setMaritalStatus("")
     setNumberOfWives(null)
     setWifeOrHusbandName({
      first: "",
      second: "",
      third: "",
      fourth: "",
      title: "",
     })

     setWifeOrHusbandHasJob(0)
     setWifeOrHusbandCareer("")
     setWifeOrHusbandBranch("")
     setWifeOrHusbandFolderNumber(null)
     
     setsignatureOfTaxPayer(0)
     setSignatureOfTaxPayerDate(new Date())
     setAgencyNo(null)
     setAgencyNoDate(new Date())
     setIssuer("")
     setNameOfSpeculativeUnitWriter("")
     setSignatureOfSpeculativeUnitWriter(0)

     setCountImage([])
     setChildrenObj([])
     setMessageErrors([])
     setCareersForGroupSelected([])
     setTimeout(()=>{
      window.location.reload();
     },500)
  }

  useEffect(() => {
    // if (countImage.length > 0) {
    //   let count = 0;
    //   countImage.map((data) => {
    //     if (!data.file) {
    //       count += 1;
    //     }
    //   });
    //   setcountFileNotExists(count);
    // }
    // createThumb();
  }, [countImage]);

  //======================================================
  // ==============store data of children================
  const setNameOfBoyOrGirl = (data, name) => {
    let arrYTMp = [];
    if (childrenObj.length > 0) {
      childrenObj.map((dataItem) => {
        if (data.index == dataItem.index) {
          let custm = {
            index: data.index,
            name: name,
            birthDate: data.birthDate,
            civilStatusCardNumber: data.civilStatusCardNumber,
            civilStatusCardDate: data.civilStatusCardDate,
            gender: data.gender,
            isMarried: data.isMarried,
          };
          arrYTMp.push(custm);
        } else {
          arrYTMp.push(dataItem);
        }
      });
      setChildrenObj(arrYTMp);
    }
  };
  const setGenderOfBoyOrGirl = (data, gender) => {
    let arrYTMp = [];
    if (childrenObj.length > 0) {
      childrenObj.map((dataItem) => {
        if (data.index == dataItem.index) {
          let custm = {
            index: data.index,
            name: data.name,
            birthDate: data.birthDate,
            civilStatusCardNumber: data.civilStatusCardNumber,
            civilStatusCardDate: data.civilStatusCardDate,
            gender: gender,
            isMarried: data.isMarried,
          };
          arrYTMp.push(custm);
        } else {
          arrYTMp.push(dataItem);
        }
      });
      setChildrenObj(arrYTMp);
    }
  };

  const setIsMarriedOfBoyOrGirl = (data, isMarried) => {
    let arrYTMp = [];
    if (childrenObj.length > 0) {
      childrenObj.map((dataItem) => {
        if (data.index == dataItem.index) {
          let custm = {
            index: data.index,
            name: data.name,
            birthDate: data.birthDate,
            civilStatusCardNumber: data.civilStatusCardNumber,
            civilStatusCardDate: data.civilStatusCardDate,
            gender: data.gender,
            isMarried: isMarried,
          };
          arrYTMp.push(custm);
        } else {
          arrYTMp.push(dataItem);
        }
      });
      setChildrenObj(arrYTMp);
    }
  };

  const setBirthDateOfBoyOrGirl = (data, birthDate) => {
    let arrYTMp = [];
    if (childrenObj.length > 0) {
      childrenObj.map((dataItem) => {
        if (data.index == dataItem.index) {
          let custm = {
            index: data.index,
            name: data.name,
            birthDate: birthDate,
            civilStatusCardNumber: data.civilStatusCardNumber,
            civilStatusCardDate: data.civilStatusCardDate,
            gender: data.gender,
            isMarried: data.isMarried,
          };
          arrYTMp.push(custm);
        } else {
          arrYTMp.push(dataItem);
        }
      });
      setChildrenObj(arrYTMp);
    }
  };

  const setCivilStatusCardNumberOfBoyOrGirl = (data, civilStatusCardNumber) => {
    let arrYTMp = [];
    if (childrenObj.length > 0) {
      childrenObj.map((dataItem) => {
        if (data.index == dataItem.index) {
          let custm = {
            index: data.index,
            name: data.name,
            birthDate: data.birthDate,
            civilStatusCardNumber: civilStatusCardNumber,
            civilStatusCardDate: data.civilStatusCardDate,
            gender: data.gender,
            isMarried: data.isMarried,
          };
          arrYTMp.push(custm);
        } else {
          arrYTMp.push(dataItem);
        }
      });
      setChildrenObj(arrYTMp);
    }
  };

  const setCivilStatusCardDateOfBoyOrGirl = (data, civilStatusCardDate) => {
    let arrYTMp = [];
    if (childrenObj.length > 0) {
      childrenObj.map((dataItem) => {
        if (data.index == dataItem.index) {
          let custm = {
            index: data.index,
            name: data.name,
            birthDate: data.birthDate,
            civilStatusCardNumber: data.civilStatusCardNumber,
            civilStatusCardDate: civilStatusCardDate,
            gender: data.gender,
            isMarried: data.isMarried,
          };
          arrYTMp.push(custm);
        } else {
          arrYTMp.push(dataItem);
        }
      });
      setChildrenObj(arrYTMp);
    }
  };
  //==========================================================
  //==========================================================

  //============format date to format yyyy-mm-dd============
  const formatDate = (date) => {
    if (!date) return null;
    let d = date;
    if (typeof d === 'string') {
      // already formatted yyyy-MM-dd
      if (/^\d{4}-\d{2}-\d{2}$/.test(d)) return d;
      // dd/MM/yyyy
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(d)) {
        const [dd, mm, yyyy] = d.split('/');
        d = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
      } else {
        const parsed = new Date(d);
        d = isNaN(parsed.getTime()) ? null : parsed;
      }
    }
    if (!(d instanceof Date) || isNaN(d.getTime())) return null;

    let y = d.getFullYear();
    let m = d.getMonth() + 1;
    if (m < 10) m = "0" + m;

    let day = d.getDate();
    if (day < 10) day = "0" + day;

    return y + "-" + m + "-" + day;
  };

  //============end format date==============================

  const removeErrorMessage = (error) => {
    setMessageErrors(messageErrors.filter((itm) => itm != error));
  };

  const checkErrorFound = (name) => {
    let ch = 0;
    if (messageErrors.length > 0) {
      messageErrors.map((itm) => {
        if (itm[name]) {
          ch = 1;
        }
      });

      if (ch == 1) {
        console.log("done here");
        return true;
      } else return false;
    } else return false;
  };

  const handleMessageError = (name, message) => {
    if (messageErrors.length > 0) {
      let count = 0;
      messageErrors.map((data) => {
        if (data[name]) {
          count = 1;
        }
      });
      if (count == 0) {
        setMessageErrors((itm) => [...itm, { [name]: message }]);
      }
    }
  };

  const nameWordCount = (name, min) => {
    let countName = name.split(" ").length;
    if (countName >= min) return true;
    else return false;
  };

  // const handleClickVariant = (message, variant) => () => {
  //   // variant could be success, error, warning, info, or default
  //   enqueueSnackbar("done", { variant });
  // };

  const getAgeFromBirthDate = (birthDate) => {
    try {
      let output = new calculateAge(birthDate, new Date()).getObject();
      console.log(output);
      if (output.years >= 18) {
        return true;
      }

      return false;
    } catch (err) {}
  };

  const setMessageErrorFrontValidate = (groupName, prop, message) => {
    setListOfMessage({
      ...listOfMessage,
      [groupName]: {
        ...listOfMessage[groupName],
        [prop]: message,
      },
    });
  };
  
  const [countImageList,setCountImageList]=useState(0);
  const  [filesObject,setFilesObject]=useState({
    index: 0,
    fileType: null,
    ImageForWhat: null,
    file: null,
    mem: null,
    imgURl: null,
    pdfCheck: 0,
  });

  const [loading3,setLoading3]=useState(false)

  const pushImageFiles = () => {
         if(countImage.lenght>0){
          let ch=0;
          countImage.map((itm)=>{
             if(itm?.file?.name==filesObject?.file?.name){
                ch=1; 
             }
          })

          if(ch==1){
            setsnackBar({
              ...snackBar,
              open: true,
              severity: "warning",
              message:
                "لا يمكنك رفع نفس الملف اكثر من مرة",
            });
            return;
          }
         }


    console.log("filesObject",filesObject);
    if(filesObject.file){
    setLoading3(true)
    console.log("countImage",countImage);
    setCountImage([...countImage,filesObject])
    setTimeout(()=>{
    setLoading3(false)
    },500)

    setFilesObject({  
      index: 0,
      fileType: null,
      ImageForWhat: null,
      file: null,
      mem: null,
      imgURl: null,
      pdfCheck: 0,
    })
    document.getElementById('Images').value=null;
  }else{
    setsnackBar({
      ...snackBar,
      open: true,
      severity: "warning",
      message:
        "يجب  ملئ البيانات الخاصة بالملف لاضافته",
    });
  }
}


const removeImage=(data)=>{
  console.log('done');

    if(countImage.length>0){
      console.log('done');
        setCountImage(countImage.filter((itm)=> itm.index!=data.index))
    }
}

const setErrorNow=(name)=>{
    if(messageErrors.length>0){
      messageErrors.map((err) => {
        if (err[name]) {
          setListOfMessage({
            ...listOfMessage,
            [name]: "",
          });
        }
      })
    }
}





  return (
    <div className="Dashboard_MOF px-0 mx-0">
      <div className="container-fluid w-100 mx-0 px-0">
        <div className="row rowContainer mx-0">
          <div className="col-md-12 col-xl-12 w-100 d-flex flex-column justify-content-center align-items-end  paddingForm">
            <div
              className={`FormContainer  ${
                props.inactive === false ? "activeSideMenu" : ""
              }`}
              style={{
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
              }}
            >
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  backgroundColor: "#5f7b8a",
                  color: "#FFFFFF",
                  paddingTop: 10,
                  paddingBottom: 10,
                  borderTopLeftRadius: 10,
                  borderTopRightRadius: 10,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <h2>تقرير ضريبة الدخل</h2>
              </div>
              {/*###==> basic information here ...  */}
              <h4
                style={{
                  marginRight: "10px",
                  marginTop: "10px",
                  color: "#5f7b8a",
                }}
              >
                المعلومات الاساسية
              </h4>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexFlow: "row wrap",

                  border: "1px solid",
                  borderColor: "#5f7b8a",
                  borderRadius: 10,
                  margin: 10,
                  paddingBottom: 10,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    // width: "50%",
                    flex: 1,

                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="رقم الضبارة"
                      variant="outlined"
                      value={folderNumber}
                      type="number"
                      helperText={listOfMessage.folderNumber}
                      error={
                        listOfMessage.folderNumber
                          ? true
                          : checkErrorFound("folderNumber")
                      }
                      onChange={(e) => {
                        if (isNaN(e.target.value)) {
                          setListOfMessage({
                            ...listOfMessage,
                            folderNumber: "يجب اني يكو رقم",
                          });
                        } else {
                          setListOfMessage({
                            ...listOfMessage,
                            folderNumber: "",
                          });
                        }
                        setFolderNumber(e.target.value);
                        if (messageErrors.length > 0)
                          messageErrors.map((err) => {
                            if (err.folderNumber) {
                              removeErrorMessage(err);
                            }
                          });
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.folderNumber) {
                            return err.folderNumber;
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    // width: "33%",
                    flex: 1,
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DesktopDatePicker
                        label="السنة"
                        inputFormat="yyyy"
                        views={["year"]}
                        value={year ? new Date(Number(year), 0, 1) : new Date()}
                        maxDate={new Date()}
                        onChange={(date) => {
                          if (date) setYear(format(date, "yyyy"));

                          if (messageErrors.length > 0)
                            messageErrors.map((err) => {
                              if (err.year) {
                                removeErrorMessage(err);
                              }
                            });
                        }}
                        error={checkErrorFound("year")}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.year) {
                            return err.year;
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    width: "50%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingLeft: 10,
                    paddingTop: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <InputLabel id="career-simple-select-label">
                      الجنس
                    </InputLabel>
                    <Select
                      labelId="career-simple-select-label"
                      id="career-simple-select"
                      value={gender}
                      label="الجنس "
                      onChange={(e) => {
                        setGender(e.target.value);
                      }}
                    >
                      <MenuItem value={0}>{"ذكر"}</MenuItem>
                      <MenuItem value={1}>{"انثى"}</MenuItem>
                    </Select>
                  </FormControl>

                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.gender) {
                            return err.gender;
                          }
                        })
                      : null}
                  </Typography>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "20%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="الاسم الاول"
                      variant="outlined"
                      value={taxPayerName.first}
                      helperText={listOfMessage.name.first}
                      error={
                        listOfMessage.name.first
                          ? true
                          : checkErrorFound("taxPayerName")
                      }
                      onChange={(e) => {
                        if (!e.target.value) {
                          setListOfMessage({
                            ...listOfMessage,
                            name: {
                              ...listOfMessage.name,
                              first: "الاسم الاول مطلوب",
                            },
                          });
                        } else {
                          setListOfMessage({
                            ...listOfMessage,
                            name: {
                              ...listOfMessage.name,
                              first: "",
                            },
                          });
                        }
                        setTaxPayerName({
                          ...taxPayerName,
                          first: e.target.value,
                        });

                        if (messageErrors.length > 0)
                          messageErrors.map((err) => {
                            if (err.taxPayerName) {
                              removeErrorMessage(err);
                            }
                          });
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.taxPayerName) {
                            return "الاسم الاول مطلوب";
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "20%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="الاسم الثاني"
                      variant="outlined"
                      value={taxPayerName.second}
                      helperText={listOfMessage.name.second}
                      error={
                        listOfMessage.name.second
                          ? true
                          : checkErrorFound("taxPayerName")
                      }
                      onChange={(e) => {
                        if (!e.target.value) {
                          setListOfMessage({
                            ...listOfMessage,
                            name: {
                              ...listOfMessage.name,
                              second: "الاسم الثاني مطلوب",
                            },
                          });
                        } else {
                          setListOfMessage({
                            ...listOfMessage,
                            name: {
                              ...listOfMessage.name,
                              second: "",
                            },
                          });
                        }
                        setTaxPayerName({
                          ...taxPayerName,
                          second: e.target.value,
                        });

                        if (messageErrors.length > 0)
                          messageErrors.map((err) => {
                            if (err.taxPayerName) {
                              removeErrorMessage(err);
                            }
                          });
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.taxPayerName) {
                            return "الاسم الثاني مطلوب";
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",

                    width: "20%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="الاسم الثالث"
                      variant="outlined"
                      value={taxPayerName.third}
                      helperText={listOfMessage.name.third}
                      error={
                        listOfMessage.name.third
                          ? true
                          : checkErrorFound("taxPayerName")
                      }
                      onChange={(e) => {
                        if (!e.target.value) {
                          setListOfMessage({
                            ...listOfMessage,
                            name: {
                              ...listOfMessage.name,
                              third: "الاسم الثالث مطلوب",
                            },
                          });
                        } else {
                          setListOfMessage({
                            ...listOfMessage,
                            name: {
                              ...listOfMessage.name,
                              third: "",
                            },
                          });
                        }
                        setTaxPayerName({
                          ...taxPayerName,
                          third: e.target.value,
                        });

                        if (messageErrors.length > 0)
                          messageErrors.map((err) => {
                            if (err.taxPayerName) {
                              removeErrorMessage(err);
                            }
                          });
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.taxPayerName) {
                            return "الاسم الثالث مطلوب";
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",

                    width: "20%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="الاسم الرابع"
                      variant="outlined"
                      value={taxPayerName.fourth}
                      helperText={listOfMessage.name.forth}
                      error={
                        listOfMessage.name.forth
                          ? true
                          : checkErrorFound("taxPayerName")
                      }
                      onChange={(e) => {
                        if (!e.target.value) {
                          setListOfMessage({
                            ...listOfMessage,
                            name: {
                              ...listOfMessage.name,
                              forth: "الاسم الرابع مطلوب",
                            },
                          });
                        } else {
                          setListOfMessage({
                            ...listOfMessage,
                            name: {
                              ...listOfMessage.name,
                              forth: "",
                            },
                          });
                        }
                        setTaxPayerName({
                          ...taxPayerName,
                          fourth: e.target.value,
                        });

                        if (messageErrors.length > 0)
                          messageErrors.map((err) => {
                            if (err.taxPayerName) {
                              removeErrorMessage(err);
                            }
                          });
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.taxPayerName) {
                            return "الاسم الرابع مطلوب";
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "20%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="اللقب"
                      variant="outlined"
                      value={taxPayerName.title}
                      helperText={listOfMessage.name.title}
                      error={
                        listOfMessage.name.title
                          ? true
                          : checkErrorFound("taxPayerName")
                      }
                      onChange={(e) => {
                        if (!e.target.value) {
                          setListOfMessage({
                            ...listOfMessage,
                            name: {
                              ...listOfMessage.name,
                              title: " اللقب مطلوب",
                            },
                          });
                        } else {
                          setListOfMessage({
                            ...listOfMessage,
                            name: {
                              ...listOfMessage.name,
                              title: "",
                            },
                          });
                        }
                        setTaxPayerName({
                          ...taxPayerName,
                          title: e.target.value,
                        });

                        if (messageErrors.length > 0)
                          messageErrors.map((err) => {
                            if (err.taxPayerName) {
                              removeErrorMessage(err);
                            }
                          });
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.taxPayerName) {
                            return " اللقب مطلوب";
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "33%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="اسم الام كامل و اللقب"
                      title="اسم الام كامل و اللقب"
                      helperText={listOfMessage.motherName}
                      variant="outlined"
                      value={motherName}
                      error={
                        listOfMessage.motherName
                          ? true
                          : checkErrorFound("motherName")
                      }
                      onChange={(e) => {
                        if (!nameWordCount(e.target.value, 4)) {
                          setListOfMessage({
                            ...listOfMessage,
                            motherName: "يرجى كتابة اسم الام الثلاثي مع اللقب",
                          });
                        } else {
                          setListOfMessage({
                            ...listOfMessage,
                            motherName: "",
                          });
                        }
                        setMotherName(e.target.value);
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.motherName) {
                            return err.motherName;
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "33%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <InputLabel id="calculation-type-simple-select-label">
                      الجنسية
                    </InputLabel>
                    <Select
                      labelId="calculation-type-simple-select-label"
                      id="calculation-type-simple-select"
                      // value={selectedCalculationType}
                      label="الجنسية "
                      value={nationality}
                      onChange={(e) => {
                        setNationality(e.target.value);
                      }}
                    >
                      <MenuItem value={"عراقية"}>عراقية</MenuItem>
                      <MenuItem value={"عربية"}>عربية</MenuItem>
                      <MenuItem value={"اجنبية"}>اجنبية</MenuItem>
                    </Select>
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.nationality) {
                            return err.nationality;
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",

                    width: "33%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DesktopDatePicker
                        label="التولد"
                        inputFormat="dd/MM/yyyy"
                        value={birthDate}
                        helperText={listOfMessage.birthDate}
                        onChange={(date) => {
                          if (!getAgeFromBirthDate(date)) {
                            setListOfMessage({
                              ...listOfMessage,
                              birthDate: "يجب ان يكون عمرك 18 على الاقل",
                            });
                          } else {
                            setListOfMessage({
                              ...listOfMessage,
                              birthDate: "",
                            });
                          }
                          setBirthDate(date);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={
                              listOfMessage.birthDate
                                ? true
                                : checkErrorFound("taxPayerName")
                            }
                            helperText={listOfMessage.birthDate}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.birthDate) {
                            return err.birthDate;
                          }
                        })
                      : null}
                  </Typography>
                </div>
              </div>
              {/*###==> civil status card here ...  */}
              <h4
                style={{
                  marginRight: "10px",
                  color: "#5f7b8a",
                }}
              >
                بطاقة الاحوال المدنية
              </h4>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexFlow: "row wrap",

                  border: "1px solid",
                  borderColor: "#5f7b8a",
                  borderRadius: 10,
                  margin: 10,
                  paddingBottom: 10,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "33%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="سجل"
                      variant="outlined"
                      value={civilStatusCardRecord}
                      helperText={listOfMessage.civilStatusCard.folderNumber}
                      error={
                        listOfMessage.civilStatusCard.folderNumber
                          ? true
                          : checkErrorFound("civilStatusCardRecord")
                      }
                      onChange={(e) => {
                        if (!e.target.value) {
                          setListOfMessage({
                            ...listOfMessage,
                            civilStatusCard: {
                              ...listOfMessage.civilStatusCard,
                              folderNumber: "هذا الحقل مطلوب",
                            },
                          });
                        } else if (isNaN(e.target.value)) {
                          setListOfMessage({
                            ...listOfMessage,
                            civilStatusCard: {
                              ...listOfMessage.civilStatusCard,
                              folderNumber: "يجب ان يكون رقم",
                            },
                          });
                        } else {
                          setListOfMessage({
                            ...listOfMessage,
                            civilStatusCard: {
                              ...listOfMessage.civilStatusCard,
                              folderNumber: "",
                            },
                          });
                        }
                        setCivilStatusCardRecord(e.target.value);

                        if (messageErrors.length > 0)
                          messageErrors.map((err) => {
                            if (err.civilStatusCardRecord) {
                              removeErrorMessage(err);
                            }
                          });
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.civilStatusCardRecord) {
                            return err.civilStatusCardRecord;
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "33%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="صفحه"
                      variant="outlined"
                      value={civilStatusCardPage}
                      helperText={listOfMessage.civilStatusCard.page}
                      error={
                        listOfMessage.civilStatusCard.page
                          ? true
                          : checkErrorFound("civilStatusCardPage")
                      }
                      onChange={(e) => {
                        if (!e.target.value) {
                          setListOfMessage({
                            ...listOfMessage,
                            civilStatusCard: {
                              ...listOfMessage.civilStatusCard,
                              page: "هذا الحقل مطلوب",
                            },
                          });
                        } else if (isNaN(e.target.value)) {
                          setListOfMessage({
                            ...listOfMessage,
                            civilStatusCard: {
                              ...listOfMessage.civilStatusCard,
                              page: "يجب ان يكون رقم",
                            },
                          });
                        } else {
                          setListOfMessage({
                            ...listOfMessage,
                            civilStatusCard: {
                              ...listOfMessage.civilStatusCard,
                              page: "",
                            },
                          });
                        }
                        setCivilStatusCardPage(e.target.value);

                        if (messageErrors.length > 0)
                          messageErrors.map((err) => {
                            if (err.civilStatusCardPage) {
                              removeErrorMessage(err);
                            }
                          });
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.civilStatusCardPage) {
                            return err.civilStatusCardPage;
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "33%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="رقم"
                      variant="outlined"
                      value={civilStatusCardNumber}
                      helperText={listOfMessage.civilStatusCard.number}
                      error={
                        listOfMessage.civilStatusCard.number
                          ? true
                          : checkErrorFound("civilStatusCardNumber")
                      }
                      onChange={(e) => {
                        if (!e.target.value) {
                          setListOfMessage({
                            ...listOfMessage,
                            civilStatusCard: {
                              ...listOfMessage.civilStatusCard,
                              number: "هذا الحقل مطلوب",
                            },
                          });
                        } else if (isNaN(e.target.value)) {
                          setListOfMessage({
                            ...listOfMessage,
                            civilStatusCard: {
                              ...listOfMessage.civilStatusCard,
                              number: "يجب ان يكون رقم",
                            },
                          });
                        } else {
                          setListOfMessage({
                            ...listOfMessage,
                            civilStatusCard: {
                              ...listOfMessage.civilStatusCard,
                              number: "",
                            },
                          });
                        }
                        setCivilStatusCardNumber(e.target.value);

                        if (messageErrors.length > 0)
                          messageErrors.map((err) => {
                            if (err.civilStatusCardNumber) {
                              removeErrorMessage(err);
                            }
                          });
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.civilStatusCardNumber) {
                            return err.civilStatusCardNumber;
                          }
                        })
                      : null}
                  </Typography>
                </div>
              </div>
              {/*###==> home address here ...  */}
              <h4
                style={{
                  marginRight: "10px",
                  color: "#5f7b8a",
                }}
              >
                عنوان السكن
              </h4>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexFlow: "row wrap",

                  border: "1px solid",
                  borderColor: "#5f7b8a",
                  borderRadius: 10,
                  margin: 10,
                  paddingBottom: 10,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "20%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingLeft: 10,
                    paddingTop: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <InputLabel id="career-simple-select-label">
                      المحافظة
                    </InputLabel>
                    <Select
                      labelId="career-simple-select-label"
                      id="career-simple-select"
                      value={homeAddressGovernorate}
                      label="المحافظة "
                      helperText={listOfMessage.HomeAddress.governoarte}
                      error={
                        listOfMessage.HomeAddress.governoarte
                          ? true
                          : checkErrorFound("homeAddressGovernorate")
                      }
                      onChange={(e) => {
                        if (!e.target.value) {
                          setListOfMessage({
                            ...listOfMessage,
                            HomeAddress: {
                              ...listOfMessage.HomeAddress,
                              governoarte: "هذا الحقل مطلوب",
                            },
                          });
                        } else {
                          setListOfMessage({
                            ...listOfMessage,
                            HomeAddress: {
                              ...listOfMessage.HomeAddress,
                              governoarte: "",
                            },
                          });
                        }
                        setHomeAddressGovernorate(e.target.value);

                        if (messageErrors.length > 0)
                          messageErrors.map((err) => {
                            if (err.homeAddressGoverNorate) {
                              removeErrorMessage(err);
                            }
                          });
                      }}
                    >
                      <MenuItem value={"بغداد"}>{"بغداد"}</MenuItem>
                      <MenuItem value={"بابل"}>{"بابل"}</MenuItem>
                      <MenuItem value={"دهوك"}>{"دهوك"}</MenuItem>
                      <MenuItem value={"الانبار"}>{"الانبار"}</MenuItem>
                      <MenuItem value={"بصر"}>{"بصر"}</MenuItem>
                      <MenuItem value={"ناصرية"}>{"ناصرية"}</MenuItem>
                      <MenuItem value={"ذي قار	"}>{"ذي قار	"}</MenuItem>
                      <MenuItem value={"القادسية"}>{"القادسية"}</MenuItem>
                      <MenuItem value={"ديالى	"}>{"ديالى	"}</MenuItem>
                      <MenuItem value={"حلبجة "}>{"حلبجة "}</MenuItem>
                      <MenuItem value={"كربلاء"}>{"كربلاء"}</MenuItem>
                      <MenuItem value={"كركوك"}>{"كركوك"}</MenuItem>
                      <MenuItem value={"ميسان"}>{"ميسان"}</MenuItem>
                      <MenuItem value={"سليمانية"}>{"سليمانية"}</MenuItem>
                      <MenuItem value={"المثنى"}>{"المثنى"}</MenuItem>
                      <MenuItem value={"النجف"}>{"النجف"}</MenuItem>
                      <MenuItem value={"نينوى"}>{"نينوى"}</MenuItem>
                      <MenuItem value={"صلاح الدين"}>{"صلاح الدين"}</MenuItem>
                    </Select>
                  </FormControl>

                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.homeAddressGoverNorate) {
                            return err.homeAddressGoverNorate;
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "20%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="قضاء"
                      variant="outlined"
                      value={homeAddressDistrict}
                      helperText={listOfMessage.HomeAddress.distric}
                      error={
                        listOfMessage.HomeAddress.distric
                          ? true
                          : checkErrorFound("homeAddressDistrict")
                      }
                      onChange={(e) => {
                        // if (!e.target.value) {
                        //   setListOfMessage({
                        //     ...listOfMessage,
                        //     HomeAddress: {
                        //       ...listOfMessage.HomeAddress,
                        //       distric: "هذا الحقل مطلوب",
                        //     },
                        //   });
                        // } else {
                        //   setListOfMessage({
                        //     ...listOfMessage,
                        //     HomeAddress: {
                        //       ...listOfMessage.HomeAddress,
                        //       distric: "",
                        //     },
                        //   });
                        // }
                        setHomeAddressDistrict(e.target.value);
                        if (messageErrors.length > 0)
                          messageErrors.map((err) => {
                            if (err.homeAddressDistrict) {
                              removeErrorMessage(err);
                            }
                          });
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.homeAddressDistrict) {
                            return err.homeAddressDistrict;
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    flexDirection: "column",
                    display: "flex",
                    width: "20%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="ناحية"
                      variant="outlined"
                      value={homeAddressTownship}
                      helperText={listOfMessage.HomeAddress.twonShip}
                      error={
                        listOfMessage.HomeAddress.twonShip
                          ? true
                          : checkErrorFound("homeAddressTownship")
                      }
                      onChange={(e) => {
                        // if (!e.target.value) {
                        //   setListOfMessage({
                        //     ...listOfMessage,
                        //     HomeAddress: {
                        //       ...listOfMessage.HomeAddress,
                        //       twonShip: "هذا الحقل مطلوب",
                        //     },
                        //   });
                        // } else {
                        //   setListOfMessage({
                        //     ...listOfMessage,
                        //     HomeAddress: {
                        //       ...listOfMessage.HomeAddress,
                        //       twonShip: "",
                        //     },
                        //   });
                        // }
                        setHomeAddressTownship(e.target.value);

                        if (messageErrors.length > 0)
                          messageErrors.map((err) => {
                            if (err.homeAddressTownship) {
                              removeErrorMessage(err);
                            }
                          });
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.homeAddressTownship) {
                            return err.homeAddressTownship;
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    flexDirection: "column",
                    display: "flex",
                    width: "20%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="قرية"
                      variant="outlined"
                      value={homeAddressVillage}
                      helperText={listOfMessage.HomeAddress.valliage}
                      error={
                        listOfMessage.HomeAddress.valliage
                          ? true
                          : checkErrorFound("homeAddressVillage")
                      }
                      onChange={(e) => {
                        // if (!e.target.value) {
                        //   setListOfMessage({
                        //     ...listOfMessage,
                        //     HomeAddress: {
                        //       ...listOfMessage.HomeAddress,
                        //       valliage: "هذا الحقل مطلوب",
                        //     },
                        //   });
                        // } else {
                        //   setListOfMessage({
                        //     ...listOfMessage,
                        //     HomeAddress: {
                        //       ...listOfMessage.HomeAddress,
                        //       valliage: "",
                        //     },
                        //   });
                        // }
                        sethomeAddressVillage(e.target.value);
                        if (messageErrors.length > 0)
                          messageErrors.map((err) => {
                            if (err.homeAddressVillage) {
                              removeErrorMessage(err);
                            }
                          });
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.homeAddressVillage) {
                            return err.homeAddressVillage;
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    flexDirection: "column",
                    display: "flex",
                    width: "20%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="رقم"
                      variant="outlined"
                      value={homeAddressNumber}
                      type="number"
                      helperText={listOfMessage.HomeAddress.number}
                      error={
                        listOfMessage.HomeAddress.number
                          ? true
                          : checkErrorFound("homeAddressNumber")
                      }
                      onChange={(e) => {
                        // if (!e.target.value) {
                        //   setListOfMessage({
                        //     ...listOfMessage,
                        //     HomeAddress: {
                        //       ...listOfMessage.HomeAddress,
                        //       number: "هذا الحقل مطلوب",
                        //     },
                        //   });
                        // } else
                        if (isNaN(e.target.value)) {
                          setListOfMessage({
                            ...listOfMessage,
                            HomeAddress: {
                              ...listOfMessage.HomeAddress,
                              number: "هذا الحقل يجب ان يكون رقم ",
                            },
                          });
                        } else {
                          setListOfMessage({
                            ...listOfMessage,
                            HomeAddress: {
                              ...listOfMessage.HomeAddress,
                              number: "",
                            },
                          });
                        }
                        setHomeAddressNumber(e.target.value);
                        if (messageErrors.length > 0)
                          messageErrors.map((err) => {
                            if (err.homeAddressNumber) {
                              removeErrorMessage(err);
                            }
                          });
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.homeAddressNumber) {
                            return err.homeAddressNumber;
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "20%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="حي"
                      variant="outlined"
                      value={homeAddressNeighborhood}
                      helperText={listOfMessage.HomeAddress.neighborhood}
                      error={
                        listOfMessage.HomeAddress.neighborhood
                          ? true
                          : checkErrorFound("homeAddressNeighborhood")
                      }
                      onChange={(e) => {
                        // if (!e.target.value) {
                        //   setListOfMessage({
                        //     ...listOfMessage,
                        //     HomeAddress: {
                        //       ...listOfMessage.HomeAddress,
                        //       neighborhood: "هذا الحقل مطلوب",
                        //     },
                        //   });
                        // } else {
                        //   setListOfMessage({
                        //     ...listOfMessage,
                        //     HomeAddress: {
                        //       ...listOfMessage.HomeAddress,
                        //       neighborhood: "",
                        //     },
                        //   });
                        // }
                        setHomeAddressNeighborhood(e.target.value);
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.homeAddressNeighborhood) {
                            return err.homeAddressNeighborhood;
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    flexDirection: "column",
                    display: "flex",
                    width: "20%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="محلة"
                      variant="outlined"
                      type={"number"}
                      value={homeAddressLocality}
                      helperText={listOfMessage.HomeAddress.locality}
                      error={
                        listOfMessage.HomeAddress.locality
                          ? true
                          : checkErrorFound("homeAddressLocality")
                      }
                      onChange={(e) => {
                        // if (!e.target.value) {
                        //   setListOfMessage({
                        //     ...listOfMessage,
                        //     HomeAddress: {
                        //       ...listOfMessage.HomeAddress,
                        //       locality: "هذا الحقل مطلوب",
                        //     },
                        //   });
                        // } else {
                        //   setListOfMessage({
                        //     ...listOfMessage,
                        //     HomeAddress: {
                        //       ...listOfMessage.HomeAddress,
                        //       locality: "",
                        //     },
                        //   });
                        // }
                        setHomeAddressLocality(e.target.value);
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.homeAddressLocality) {
                            return err.homeAddressLocality;
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "20%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="زقاق"
                      type={"number"}
                      variant="outlined"
                      value={homeAddressAlley}
                      helperText={listOfMessage.HomeAddress.alley}
                      error={
                        listOfMessage.HomeAddress.alley
                          ? true
                          : checkErrorFound("homeAddressAlley")
                      }
                      onChange={(e) => {
                        // if (!e.target.value) {
                        //   setListOfMessage({
                        //     ...listOfMessage,
                        //     HomeAddress: {
                        //       ...listOfMessage.HomeAddress,
                        //       alley: "هذا الحقل مطلوب",
                        //     },
                        //   });
                        // } else {
                        //   setListOfMessage({
                        //     ...listOfMessage,
                        //     HomeAddress: {
                        //       ...listOfMessage.HomeAddress,
                        //       alley: "",
                        //     },
                        //   });
                        // }
                        setHomeAddressAlley(e.target.value);
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.homeAddressAlley) {
                            return err.homeAddressAlley;
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    flexDirection: "column",
                    display: "flex",
                    width: "20%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="دار"
                      variant="outlined"
                      value={homeAddressHouse}
                      helperText={listOfMessage.HomeAddress.house}
                      error={
                        listOfMessage.HomeAddress.house
                          ? true
                          : checkErrorFound("homeAddressDistrict")
                      }
                      onChange={(e) => {
                        // if (!e.target.value) {
                        //   setListOfMessage({
                        //     ...listOfMessage,
                        //     HomeAddress: {
                        //       ...listOfMessage.HomeAddress,
                        //       house: "هذا الحقل مطلوب",
                        //     },
                        //   });
                        // } else {
                        //   setListOfMessage({
                        //     ...listOfMessage,
                        //     HomeAddress: {
                        //       ...listOfMessage.HomeAddress,
                        //       house: "",
                        //     },
                        //   });
                        // }
                        setHomeAddressHouse(e.target.value);
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.homeAddressHouse) {
                            return err.homeAddressHouse;
                          }
                        })
                      : null}
                  </Typography>
                </div>
              </div>
              {/*###==> career info here ...  */}
              <h4
                style={{
                  marginRight: "10px",
                  color: "#5f7b8a",
                }}
              >
                معلومات المهنة والعمل
              </h4>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexFlow: "row wrap",

                  border: "1px solid",
                  borderColor: "#5f7b8a",
                  borderRadius: 10,
                  margin: 10,
                  paddingBottom: 10,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    // width: "23%",
                    flex: 1,
                    minWidth: 200,
                    marginTop: 10,
                    paddingLeft: 10,
                    paddingTop: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth className="d-flex flex-row">
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            value={hasJob == 1 ? true : false}
                            onChange={(e) => {
                              if (e.target.checked == true) {
                                setHasJob(1);
                              } else {
                                setHasJob(0);
                              }
                            }}
                          />
                        }
                        label="موظفة/موظف"
                      />
                    </FormGroup>
                  </FormControl>

                  <Typography className="fontForError"></Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    // width: "20%",
                    flex: 1,
                    minWidth: 200,
                    marginTop: 10,
                    paddingLeft: 10,
                    paddingTop: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <InputLabel id="career-simple-select-label">
                      مجموعة المهن
                    </InputLabel>
                    <Select
                      labelId="career-simple-select-label"
                      id="career-simple-select"
                      // value={career}
                      label="  مجموعة المهن "
                      helperText={listOfMessage.careerInfo.group}
                      error={listOfMessage.careerInfo.group ? true : false}
                      onChange={(e) => {
                        // setCareer(e.target.value);
                        if (!e.target.value) {
                          setListOfMessage({
                            ...listOfMessage,
                            careerInfo: {
                              ...listOfMessage.careerInfo,
                              group: "هذا الحقل مطلوب",
                            },
                          });
                        } else {
                          setListOfMessage({
                            ...listOfMessage,
                            careerInfo: {
                              ...listOfMessage.careerInfo,
                              group: "",
                            },
                          });
                        }
                        getSpecificCareersForGrou(e.target.value);
                      }}
                    >
                      {GroupsOfCareers.length > 0
                        ? GroupsOfCareers.map((data) => (
                            <MenuItem value={data.name} key={`${data.id}`}>
                              {data.name}
                            </MenuItem>
                          ))
                        : null}
                    </Select>
                  </FormControl>

                  <Typography className="fontForError"></Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    // width: "20%",
                    flex: 1,
                    flexDirection: "column",

                    minWidth: 200,
                    marginTop: 10,
                    paddingLeft: 10,
                    paddingTop: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <InputLabel id="career-simple-select-label">
                      المهنة
                    </InputLabel>
                    <Select
                      labelId="career-simple-select-label"
                      id="career-simple-select"
                      // value={career}
                      label="المحافظة "
                      helperText={listOfMessage.careerInfo.careerName}
                      error={listOfMessage.careerInfo.careerName ? true : false}
                      onChange={(e) => {
                        if (!e.target.value) {
                          setListOfMessage({
                            ...listOfMessage,
                            careerInfo: {
                              ...listOfMessage.careerInfo,
                              careerName: "هذا الحقل مطلوب",
                            },
                          });
                        } else {
                          setListOfMessage({
                            ...listOfMessage,
                            careerInfo: {
                              ...listOfMessage.careerInfo,
                              careerName: "",
                            },
                          });
                        }
                        setCareer(e.target.value);
                      }}
                    >
                      {careersForGroupSelected?.length > 0
                        ? careersForGroupSelected.map((data) => (
                            <MenuItem value={data.name} key={`${data.id}`}>
                              {data.name}
                            </MenuItem>
                          ))
                        : null}
                    </Select>
                  </FormControl>

                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.career) {
                            return err.career;
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    // width: "33%",
                    flex: 1,
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="الاسم التجاري"
                      variant="outlined"
                      value={tradeName}
                      helperText={listOfMessage.careerInfo.tradeName}
                      error={listOfMessage.careerInfo.tradeName ? true : false}
                      onChange={(e) => {
                        if (!e.target.value) {
                          setMessageErrorFrontValidate(
                            "careerInfo",
                            "tradeName",
                            "هذا الحقل مطلوب"
                          );
                        } else {
                          setMessageErrorFrontValidate(
                            "careerInfo",
                            "tradeName",
                            ""
                          );
                        }
                        setTradeName(e.target.value);
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.tradeName) {
                            return err.tradeName;
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    // width: "33%",
                    flexDirection: "column",
                    flex: 1,

                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="عنوان محل العمل"
                      variant="outlined"
                      value={addressOfWork}
                      helperText={listOfMessage.careerInfo.addressOfWork}
                      error={
                        listOfMessage.careerInfo.addressOfWork ? true : false
                      }
                      onChange={(e) => {
                        if (!e.target.value) {
                          setMessageErrorFrontValidate(
                            "careerInfo",
                            "addressOfWork",
                            "هذا الحقل مطلوب"
                          );
                        } else {
                          setMessageErrorFrontValidate(
                            "careerInfo",
                            "addressOfWork",
                            ""
                          );
                        }
                        setAddressOfWork(e.target.value);
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.addressOfWork) {
                            return err.addressOfWork;
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    flexDirection: "column",
                    display: "flex",
                    width: "100%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="تقدير المكلف لصافي دخله من جميع المصادر"
                      multiline
                      minRows={4}
                      value={estimateIncomeFromAllResources}
                      variant="outlined"
                      onChange={(e) => {
                        setEstimateIncomeFromAllResources(e.target.value);
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.estimateIncomeFromAllResources) {
                            return err.estimateIncomeFromAllResources;
                          }
                        })
                      : null}
                  </Typography>
                </div>
              </div>
              {/*###==> phone number info here ...  */}
              <h4
                style={{
                  marginRight: "10px",
                  color: "#5f7b8a",
                }}
              >
                ارقام الهاتف
              </h4>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexFlow: "row wrap",

                  border: "1px solid",
                  borderColor: "#5f7b8a",
                  borderRadius: 10,
                  margin: 10,
                  paddingBottom: 10,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "50%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="السكن"
                      variant="outlined"
                      value={phoneNumberOfHome}
                      type="number"
                      helperText={listOfMessage.phones.p_home}
                      error={listOfMessage.phones.p_home ? true : false}
                      onChange={(e) => {
                        if (!e.target.value) {
                          setMessageErrorFrontValidate(
                            "phones",
                            "p_home",
                            "هذا الحقل مطلوب"
                          );
                        } else {
                          setMessageErrorFrontValidate("phones", "p_home", "");
                        }
                        setPhoneNumberOfHome(e.target.value);
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.phoneNumberHome) {
                            return err.phoneNumberHome;
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    flexDirection: "column",
                    display: "flex",
                    width: "50%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="العمل"
                      variant="outlined"
                      type={"number"}
                      helperText={listOfMessage.phones.p_work}
                      error={listOfMessage.phones.p_work ? true : false}
                      value={phoneNumberOfWork}
                      onChange={(e) => {
                        if (!e.target.value) {
                          setMessageErrorFrontValidate(
                            "phones",
                            "p_work",
                            "هذا الحقل مطلوب"
                          );
                        } else {
                          setMessageErrorFrontValidate("phones", "p_work", "");
                        }
                        setPhoneNumberOfWork(e.target.value);
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.phoneNumberWork) {
                            return err.phoneNumberWork;
                          }
                        })
                      : null}
                  </Typography>
                </div>
              </div>
              {/*###==> marital status here ...  */}
              <h4
                style={{
                  marginRight: "10px",
                  color: "#5f7b8a",
                }}
              >
                الحالة الاجتماعية{" "}
              </h4>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexFlow: "row wrap",

                  border: "1px solid",
                  borderColor: "#5f7b8a",
                  borderRadius: 10,
                  margin: 10,
                  paddingBottom: 10,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "20%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingLeft: 10,
                    paddingTop: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <InputLabel id="career-simple-select-label">
                      الحالة الاجتماعية
                    </InputLabel>
                    <Select
                      labelId="career-simple-select-label"
                      id="career-simple-select"
                      value={maritalStatus}
                      label="الحالة الاجتماعية "
                      helperText={listOfMessage.maritalStatus.status}
                      error={listOfMessage.maritalStatus.status ? true : false}
                      onChange={(e) => {
                        if (!e.target.value) {
                          setMessageErrorFrontValidate(
                            "maritalStatus",
                            "status",
                            "هذا الحقل مطلوب"
                          );
                        } else {
                          setMessageErrorFrontValidate(
                            "maritalStatus",
                            "status",
                            ""
                          );
                        }
                        setMaritalStatus(e.target.value);
                        if (e.target.value == "متزوج") {
                          setNumberOfWives(1);
                        } else {
                          setNumberOfWives(0);
                        }
                      }}
                    >
                      <MenuItem value={"اعزب"}>{"اعزب"}</MenuItem>
                      <MenuItem value={"متزوج"}>{"متزوج"}</MenuItem>
                      <MenuItem value={"مطلق"}>{"مطلق"}</MenuItem>
                      <MenuItem value={"ارمل"}>{"ارمل"}</MenuItem>
                    </Select>
                  </FormControl>

                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.maritalStatus) {
                            return err.maritalStatus;
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "20%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="عدد الزوجات"
                      variant="outlined"
                      type={"number"}
                      value={numberOfWives}
                      onChange={(e) => {
                        setNumberOfWives(e.target.value);
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.numberOfWives) {
                            return err.numberOfWives;
                          }
                        })
                      : null}
                  </Typography>
                </div>
              </div>
              {/*###==> marital status other info  here ...  */}
              <h4
                style={{
                  marginRight: "10px",
                  color: "#5f7b8a",
                }}
              >
                معلومات الزوجة / الزوج
              </h4>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexFlow: "row wrap",

                  border: "1px solid",
                  borderColor: "#5f7b8a",
                  borderRadius: 10,
                  margin: 10,
                  paddingBottom: 10,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "20%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="الاسم الاول"
                      variant="outlined"
                      value={wifeOrHusbandName.first}
                      onChange={(e) => {
                        setWifeOrHusbandName({
                          ...wifeOrHusbandName,
                          first: e.target.value,
                        });
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.wifeOrHusbandName) {
                            return err.wifeOrHusbandName;
                          }
                        })
                      : null}
                  </Typography>
                </div>

                <div
                  style={{
                    flexDirection: "column",
                    display: "flex",
                    width: "20%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="الاسم الثاني"
                      variant="outlined"
                      value={wifeOrHusbandName.second}
                      onChange={(e) => {
                        setWifeOrHusbandName({
                          ...wifeOrHusbandName,
                          second: e.target.value,
                        });
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.wifeOrHusbandName) {
                            return err.wifeOrHusbandName;
                          }
                        })
                      : null}
                  </Typography>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "20%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="الاسم الثالث"
                      variant="outlined"
                      value={wifeOrHusbandName.third}
                      onChange={(e) => {
                        setWifeOrHusbandName({
                          ...wifeOrHusbandName,
                          third: e.target.value,
                        });
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.wifeOrHusbandName) {
                            return err.wifeOrHusbandName;
                          }
                        })
                      : null}
                  </Typography>
                </div>

                <div
                  style={{
                    flexDirection: "column",
                    display: "flex",
                    width: "20%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="الاسم الرابع"
                      variant="outlined"
                      value={wifeOrHusbandName.fourth}
                      onChange={(e) => {
                        setWifeOrHusbandName({
                          ...wifeOrHusbandName,
                          fourth: e.target.value,
                        });
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.wifeOrHusbandName) {
                            return err.wifeOrHusbandName;
                          }
                        })
                      : null}
                  </Typography>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "20%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="اللقب"
                      variant="outlined"
                      value={wifeOrHusbandName.title}
                      onChange={(e) => {
                        setWifeOrHusbandName({
                          ...wifeOrHusbandName,
                          title: e.target.value,
                        });
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.wifeOrHusbandName) {
                            return err.wifeOrHusbandName;
                          }
                        })
                      : null}
                  </Typography>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    // width: "23%",
                    flex: 1,
                    minWidth: 200,
                    marginTop: 10,
                    paddingLeft: 10,
                    paddingTop: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth className="d-flex flex-row">
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            value={WifeOrHusbandHasJob == 1 ? true : false}
                            onChange={(e) => {
                              if (e.target.checked == true) {
                                setWifeOrHusbandHasJob(1);
                              } else {
                                setWifeOrHusbandHasJob(0);
                              }
                            }}
                          />
                        }
                        label="موظف/موظفة"
                      />
                    </FormGroup>
                  </FormControl>

                  <Typography className="fontForError"></Typography>
                </div>
                {WifeOrHusbandHasJob == 1 ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      // width: "20%",
                      flex: 1,
                      minWidth: 200,
                      marginTop: 10,
                      paddingTop: 10,
                      paddingLeft: 10,
                      paddingRight: 10,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FormControl fullWidth>
                      <TextField
                        label="المهنة"
                        variant="outlined"
                        value={wifeOrHusbandCareer}
                        helperText={listOfMessage.wifrOrhusbandInfo.career}
                        error={
                          listOfMessage.wifrOrhusbandInfo.career ? true : false
                        }
                        onChange={(e) => {
                          if (!e.target.value && WifeOrHusbandHasJob == 1) {
                            setMessageErrorFrontValidate(
                              "wifrOrhusbandInfo",
                              "career",
                              "هذا الحقل مطلوب"
                            );
                          } else {
                            setMessageErrorFrontValidate(
                              "wifrOrhusbandInfo",
                              "career",
                              ""
                            );
                          }
                          setWifeOrHusbandCareer(e.target.value);
                        }}
                      />
                    </FormControl>
                    <Typography className="fontForError">
                      {messageErrors.length > 0
                        ? messageErrors.map((err) => {
                            if (err.wifeOrHusbandCareer) {
                              return err.wifeOrHusbandCareer;
                            }
                          })
                        : null}
                    </Typography>
                  </div>
                ) : null}

                <div
                  style={{
                    display: "flex",
                    // width: "20%",
                    flexDirection: "column",
                    flex: 1,
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="رقم الاضبارة"
                      variant="outlined"
                      type={"number"}
                      value={wifeOrHusbandFolderNumber}
                      helperText={listOfMessage.folderNumber}
                      onChange={(e) => {
                        setWifeOrHusbandFolderNumber(e.target.value);
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.wifeOrHusbandFolderNumber) {
                            return err.wifeOrHusbandFolderNumber;
                          }
                        })
                      : null}
                  </Typography>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    // width: "20%",
                    flex: 1,
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="الفرع"
                      variant="outlined"
                      value={wifeOrHusbandBranch}
                      onChange={(e) => {
                        setWifeOrHusbandBranch(e.target.value);
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.wifeOrHusbandBranch) {
                            return err.wifeOrHusbandBranch;
                          }
                        })
                      : null}
                  </Typography>
                </div>
              </div>

              {/*###==> signature of taxpayer and speculatie here ...  */}
              <h4
                style={{
                  marginRight: "10px",
                  color: "#5f7b8a",
                }}
              >
                {" معلومات الوكالة"}
              </h4>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexFlow: "row wrap",

                  border: "1px solid",
                  borderColor: "#5f7b8a",
                  borderRadius: 10,
                  margin: 10,
                  paddingBottom: 10,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    // width: "23%",
                    flex:1,
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="رقم الوكالة"
                      variant="outlined"
                      type={"number"}
                      value={agencyNo}
                      onChange={(e) => {
                        setAgencyNo(e.target.value);
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.agencyNo) {
                            return err.agencyNo;
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    // width: "23%",
                    flex:1,
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DesktopDatePicker
                        label="تاريخ  الوكالة"
                        inputFormat="dd/MM/yyyy"
                        value={(typeof agencyNoDate === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(agencyNoDate)) ? new Date(Number(agencyNoDate.slice(0,4)), Number(agencyNoDate.slice(5,7))-1, Number(agencyNoDate.slice(8,10))) : (agencyNoDate instanceof Date ? agencyNoDate : null)}
                        onChange={(date) => {
                          const val = (date instanceof Date && !isNaN(date.getTime())) ? date : null;
                          setAgencyNoDate(val);
                        }}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.agencyNoDate) {
                            return err.agencyNoDate;
                          }
                        })
                      : null}
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    // width: "23%",
                    flex:1,
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label=" جهة الاصدار"
                      variant="outlined"
                      value={issuer}
                      onChange={(e) => {
                        setIssuer(e.target.value);
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError">
                    {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.issuer) {
                            return err.issuer;
                          }
                        })
                      : null}
                  </Typography>
                </div>
                {
                cookies.get('role_id')==5?
                <div style={{display:'flex'}}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                      minWidth: 200,
                      marginTop: 10,
                      paddingTop: 10,
                      paddingLeft: 10,
                      paddingRight: 10,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FormControl fullWidth>
                      <TextField
                        label="أسم كاتب الوحدة التخمينية"
                        variant="outlined"
                        value={nameOfSpeculativeUnitWriter}
                        onChange={(e) => {
                          setNameOfSpeculativeUnitWriter(e.target.value);
                        }}
                      />
                    </FormControl>
                    <Typography className="fontForError">
                      {messageErrors.length > 0
                        ? messageErrors.map((err) => {
                            if (err?.nameOfSpeculativeUnitWriter) {
                              return err.nameOfSpeculativeUnitWriter;
                            }
                          })
                        : null}
                    </Typography>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      // width: "23%",
                      flex: 1,
                      minWidth: 200,
                      marginTop: 10,
                      paddingLeft: 10,
                      paddingTop: 10,
                      paddingRight: 10,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FormControl fullWidth className="d-flex flex-row">
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              value={signatureOfSpeculativeUnitWriter == 1 ? true : false}
                              onChange={(e) => {
                                if (e.target.checked == true) {
                                  setSignatureOfSpeculativeUnitWriter(1);
                                } else {
                                  setSignatureOfSpeculativeUnitWriter(0);
                                }
                              }}
                            />
                          }
                          label="موافقة كاتب الوحدة التخمينية"
                        />
                      </FormGroup>
                    </FormControl>

                    <Typography className="fontForError"></Typography>
                  </div>
                </div>:null
                }
              </div>

              {/*###==>children list ...  */}
              <h4
                style={{
                  marginRight: "10px",
                  color: "#5f7b8a",
                }}
              >
                الاولاد المشمولين بالسماح{" "}
              </h4>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexFlow: "row wrap",
                  width: "98%",
                  minWidth: 200,
                  border: "1px solid",
                  borderColor: "#5f7b8a",
                  borderRadius: 10,
                  margin: 10,
                  paddingBottom: 10,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingLeft: 10,
                    paddingTop: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <AddCircleSharpIcon
                      onClick={() => {
                        setChildrenObj((count) => [
                          ...count,
                          {
                            index: childrenObj.length + 1,
                            name: "",
                            birthDate: "",
                            civilStatusCardNumber: null,
                            civilStatusCardDate: "",
                            gender: 0,
                            isMarried: 0,
                          },
                        ]);
                      }}
                      style={{
                        fontSize: 40,
                        // borderRadius: "10px",
                        // backgroundColor: Styles.Colors.MOF_Modal_BGcolor,
                        color: Styles.Colors.MOF_Modal_BGcolor,
                        cursor: "pointer",
                      }}
                    />
                  </FormControl>

                  <Typography className="fontForError"></Typography>
                </div>

                {childrenObj.length > 0
                  ? childrenObj.map((data) => (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          flexFlow: "row wrap",
                          width: "100%",
                          minWidth: 200,
                          // border: "1px solid",
                          borderColor: "#5f7b8a",
                          borderRadius: 10,
                          margin: 10,
                          paddingBottom: 10,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            // width: "20%",
                            flex: 0.1,
                            // minWidth: 200,
                            marginTop: 10,
                            paddingLeft: 10,
                            paddingTop: 10,
                            paddingRight: 10,
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <FormControl fullWidth>
                            <RemoveCircleSharpIcon
                              onClick={() => {
                                setChildrenObj(
                                  childrenObj.filter(
                                    (itm) => itm.index != data.index
                                  )
                                );
                              }}
                              style={{
                                fontSize: 40,
                                // borderRadius: "10px",
                                // backgroundColor: Styles.Colors.MOF_Modal_BGcolor,
                                color: Styles.Colors.MOF_Modal_BGcolor,
                                cursor: "pointer",
                              }}
                            />
                          </FormControl>

                          <Typography className="fontForError"></Typography>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            // width: "20%",
                            flex: 1,
                            minWidth: 200,
                            marginTop: 10,
                            paddingTop: 10,
                            paddingLeft: 10,
                            paddingRight: 10,
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <FormControl fullWidth>
                            <TextField
                              label="اسم الولد او البنت "
                              variant="outlined"
                              value={data.name}
                              onChange={(e) => {
                                setNameOfBoyOrGirl(data, e.target.value);
                              }}
                            />
                          </FormControl>
                          <Typography className="fontForError"></Typography>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            // width: "20%",
                            flex: 1,
                            minWidth: 200,
                            marginTop: 10,
                            paddingLeft: 10,
                            paddingTop: 10,
                            paddingRight: 10,
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <FormControl fullWidth>
                            <InputLabel id="career-simple-select-label">
                              الجنس
                            </InputLabel>
                            <Select
                              labelId="career-simple-select-label"
                              id="career-simple-select"
                              value={data.gender == 1 ? "أنثى" : "ذكر"}
                              label="الجنس"
                              onChange={(e) => {
                                // setCareer(e.target.value);
                                if (e.target.value == "ذكر") {
                                  setGenderOfBoyOrGirl(data, 0);
                                } else {
                                  setGenderOfBoyOrGirl(data, 1);
                                }
                              }}
                            >
                              <MenuItem value={"ذكر"} key={"ذكر"}>
                                {"ذكر"}
                              </MenuItem>
                              <MenuItem value={"أنثى"} key={"أنثى"}>
                                {"أنثى"}
                              </MenuItem>
                            </Select>
                          </FormControl>

                          <Typography className="fontForError"></Typography>
                        </div>
                        {data.gender == 1 ? (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              // width: "20%",
                              flex: 1,
                              minWidth: 200,
                              marginTop: 10,
                              paddingLeft: 10,
                              paddingTop: 10,
                              paddingRight: 10,
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <FormControl fullWidth>
                              <InputLabel id="career-simple-select-label">
                                الحالة الزوجية
                              </InputLabel>
                              <Select
                                labelId="career-simple-select-label"
                                id="career-simple-select"
                                value={
                                  data.isMarried == 1 ? "متزوجة" : "غير متزوجة"
                                }
                                error={
                                  data.gender == 1 && data.isMarried == 1
                                    ? true
                                    : false
                                }
                                helperText={
                                  data.gender == 1 && data.isMarried == 1
                                    ? " هذا الفتات ليس له سماح وذالك لان هية متزوجة"
                                    : ""
                                }
                                label="الحالة الزوجية"
                                onChange={(e) => {
                                  // setCareer(e.target.value);
                                  if (e.target.value == "متزوجة") {
                                    setIsMarriedOfBoyOrGirl(data, 1);
                                  } else {
                                    setIsMarriedOfBoyOrGirl(data, 0);
                                  }
                                }}
                              >
                                <MenuItem
                                  value={"متزوجة"}
                                  key={"متزوج | متزوجة"}
                                >
                                  {"متزوجة"}
                                </MenuItem>
                                <MenuItem
                                  value={"غير متزوجة"}
                                  key={"غير متزوجة"}
                                >
                                  {"غير متزوجة"}
                                </MenuItem>
                              </Select>
                            </FormControl>

                            <Typography className="fontForError">
                              {data.gender == 1 && data.isMarried == 1
                                ? " هذا الفتات ليس له سماح وذالك لان هية متزوجة"
                                : ""}
                            </Typography>
                          </div>
                        ) : null}
                        <div
                          style={{
                            display: "flex",
                            width: "33%",
                            // flex: 1,
                            minWidth: 200,
                            marginTop: 10,
                            paddingTop: 10,
                            paddingLeft: 10,
                            paddingRight: 10,
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <FormControl fullWidth>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <DesktopDatePicker
                                label="تاريخ  الولادة"
                                inputFormat="dd/MM/yyyy"
                                value={data.birthDate}
                                error={listOfMessage.children ? true : false}
                                onChange={(birthdate) => {
                                  // setAgencyNoDate(date);

                                  setBirthDateOfBoyOrGirl(data, birthdate);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    error={
                                      data.gender == 0 &&
                                      getAgeFromBirthDate(data.birthDate)
                                        ? true
                                        : false
                                    }
                                    helperText={
                                      data.gender == 0 &&
                                      getAgeFromBirthDate(data.birthDate)
                                        ? "هذا طفل ليس له سماح لان عمره اكبر من 18"
                                        : ""
                                    }
                                  />
                                )}
                              />
                            </LocalizationProvider>
                          </FormControl>
                          <Typography className="fontForError"></Typography>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            width: "33%",
                            // flex: 1,
                            minWidth: 200,
                            marginTop: 10,
                            paddingTop: 10,
                            paddingLeft: 10,
                            paddingRight: 10,
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <FormControl fullWidth>
                            <TextField
                              label="رقم بطاقة الاحوال المدنية"
                              variant="outlined"
                              value={data.civilStatusCardNumber}
                              onChange={(e) => {
                                setCivilStatusCardNumberOfBoyOrGirl(
                                  data,
                                  e.target.value
                                );
                              }}
                            />
                          </FormControl>
                          <Typography className="fontForError"></Typography>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            width: "33%",
                            // flex: 1,
                            minWidth: 200,
                            marginTop: 10,
                            paddingTop: 10,
                            paddingLeft: 10,
                            paddingRight: 10,
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <FormControl fullWidth>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <DesktopDatePicker
                                label="تاريخ بطاقة الاحوال المدنية"
                                inputFormat="dd/MM/yyyy"
                                value={data.civilStatusCardDate}
                                onChange={(birthdate) => {
                                  // setAgencyNoDate(date);
                                  setCivilStatusCardDateOfBoyOrGirl(
                                    data,
                                    birthdate
                                  );
                                }}
                                renderInput={(params) => (
                                  <TextField {...params} />
                                )}
                              />
                            </LocalizationProvider>
                          </FormControl>
                          <Typography className="fontForError"></Typography>
                        </div>
                      </div>
                    ))
                  : null}
              </div>

              {/*###==>images upload ...  */}
              <h4
                style={{
                  marginRight: "10px",
                  color: "#5f7b8a",
                }}
              >
                المستمسكات{" "}
              </h4>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexFlow: "row wrap",
                  width: "98%",
                  minWidth: 200,
                  border: "1px solid",
                  borderColor: "#5f7b8a",
                  borderRadius: 10,
                  margin: 10,
                  paddingBottom: 10,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    minWidth: 200,
                    marginTop: 10,
                    paddingLeft: 10,
                    paddingTop: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <AddCircleSharpIcon
                      className="hoverPluse"
                      onClick={() => {
                        if(countImageList==0)
                          setCountImageList(1)
                      }}
                      style={{
                        fontSize: 40,
                        color: Styles.Colors.MOF_Modal_BGcolor,
                        cursor: "pointer",
                      }}
                    />
                  </FormControl>

                  <Typography className="fontForError"></Typography>
                </div>

                {countImageList ==1  ?
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          flexFlow: "row wrap",
                          width: "100%",
                          minWidth: 200,
                          // border: "1px solid",
                          borderColor: "#5f7b8a",
                          borderRadius: 10,
                          margin: 10,
                          paddingBottom: 10,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            // width: "20%",
                            flex: 1,
                            minWidth: 200,
                            marginTop: 10,
                            paddingLeft: 10,
                            paddingTop: 10,
                            paddingRight: 10,
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <FormControl fullWidth>
                            <InputLabel id="career-simple-select-label">
                              نوع الملف
                            </InputLabel>
                            <Select
                              labelId="career-simple-select-label"
                              id="career-simple-select"
                              value={filesObject.fileType?filesObject.fileType:null}
                              label="نوع الملف "
                              onChange={(e) => {
                                // setFileType(e.target.value);
                                
                                if (e.target.value == "image") {
                                  console.log(e.target.value);
                                     setFilesObject({
                                      ...filesObject,
                                      index:countImage.length+1,
                                      fileType :e.target.value,
                                      mem: "image/png,image/jpg,image/jpeg",
                                     })

                                } else if (e.target.value == "pdf") {
                                  setFilesObject({
                                    ...filesObject,
                                    index:countImage.length+1,
                                    fileType:e.target.value,
                                    mem: "application/pdf",
                                   })
                                 
                                }
                              }}
                            >
                              <MenuItem value={"image"}>{"صورة"}</MenuItem>
                              <MenuItem value={"pdf"}>{"ملف pdf"}</MenuItem>
                            </Select>
                          </FormControl>

                          <Typography className="fontForError"></Typography>
                        </div>
                        {filesObject.fileType == "image" ? (
                          <div
                            style={{
                              display: "flex",
                              // width: "20%",
                              flex: 1,
                              minWidth: 200,
                              marginTop: 10,
                              paddingLeft: 10,
                              paddingTop: 10,
                              paddingRight: 10,
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <FormControl fullWidth>
                              <InputLabel id="career-simple-select-label">
                                يرجا اختيار اسم الصورة
                              </InputLabel>
                              <Select
                                labelId="career-simple-select-label"
                                id="career-simple-select"
                                value={filesObject.ImageForWhat?filesObject.ImageForWhat:null}
                                label="يرجا اختيار اسم الصورة"
                                onChange={(e) => {
                                  setFilesObject({
                                    ...filesObject,
                                    index:countImage.length+1,
                                    ImageForWhat: e.target.value,
                                   })
                                
                                }}
                              >
                                <MenuItem value={"بطاقة الاحوال المدنية"}>
                                  {"بطاقة الاحوال المدنية"}
                                </MenuItem>
                                <MenuItem value={"بطاقة السكن"}>
                                  {"بطاقة سكن "}
                                </MenuItem>
                              </Select>
                            </FormControl>

                            <Typography className="fontForError"></Typography>
                          </div>
                        ) : null}
                        <div
                          style={{
                            display: "flex",
                            // width: "20%",
                            flex: 1,
                            minWidth: 200,
                            marginTop: 10,
                            paddingTop: 10,
                            paddingLeft: 10,
                            paddingRight: 10,
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <FormControl fullWidth>
                            <span
                              // href="#"
                              onClick={() => {
                                if (filesObject.fileType) {
                                  if (filesObject.fileType == "image") {
                                    if (filesObject.ImageForWhat) {
                                      document
                                        .querySelector(".images")
                                        .click();
                                    } else {
                                      setsnackBar({
                                        ...snackBar,
                                        open: true,
                                        severity: "warning",
                                        message:
                                          "يجب اختيار اسم الصورة لرفع الملف",
                                      });
                                    }
                                  } else {
                                    document
                                      .querySelector(".images")
                                      .click();
                                  }
                                } else {
                                  setsnackBar({
                                    ...snackBar,
                                    open: true,
                                    severity: "warning",
                                    message: "يجب اختيار نوع الصورة لرفع الملف",
                                  });
                                }
                              }}
                            >
                              <button class="boton">ارفع مستند</button>
                            </span>
                            <input
                              type="file"
                              id="Images"
                              className="images d-none"
                              name="images"
                              accept={filesObject.mem?filesObject.mem:null}
                              onChange={(e) => {
                                console.log(filesObject);
                                // e.target.click();
                                if(filesObject.fileType=='image'){
                                  console.log('d2');
                                  setFilesObject({
                                    ...filesObject,
                                    index:countImage.length+1,
                                    file: e.target.files[0],
                                    mem: "image/png,image/jpg,image/jpeg",
                                    imgURl: window.URL.createObjectURL(e.target.files[0]),
                                    pdfCheck: 0,
                                   })
                                }else if(filesObject.fileType=='pdf'){
                                  console.log('d1');
                                  setFilesObject({
                                    ...filesObject,
                                    index:countImage.length+1,
                                    file: e.target.files[0],
                                    mem: "application/pdf",
                                    imgURl:"https://play-lh.googleusercontent.com/BkRfMfIRPR9hUnmIYGDgHHKjow-g18-ouP6B2ko__VnyUHSi1spcc78UtZ4sVUtBH4g",
                                    pdfCheck: 1,
                                   })
                                }

                              }}
                            />
                          </FormControl>
                          <Typography className="fontForError"></Typography>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            // width: "20%",
                            flex: 1,
                            minWidth: 200,
                            marginTop: 10,
                            paddingLeft: 10,
                            paddingTop: 10,
                            paddingRight: 10,
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <FormControl fullWidth>
                          <Button
                             variant="contained"
                             style={{
                             backgroundColor: "#5f7b8a",
                             width: "40%",
                              fontSize: "20px",
                            }}
                            onClick={() => {
                            //  sentDateOfForm();
                            pushImageFiles();
                              
                            }}
                >
                     {!loading3 ? (
                    "أضافة"
                  ) : (
                    <div class="spinner-border " role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  )}
                </Button>
                          </FormControl>

                          <Typography className="fontForError"></Typography>
                        </div>
                      </div>
                    
                  : null}

                { countImage.length>0 ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      flexFlow: "row wrap",
                      width: "100%",
                      minWidth: 200,
                      border: "1px solid",
                      borderColor: "#5f7b8a",
                      borderRadius: 10,
                      margin: 10,
                      paddingBottom: 10,
                      justifyContent: "start",
                      alignItems: "center",
                      paddingTop: 10,
                      paddingRight: 10,
                      overflowX: "scroll",
                    }}
                  >
                    {countImage.map((data) => {
                      
                        return (
                          <div className="ownerImage">
                            <div className="deleteBox">
                              <DeleteSharpIcon className="iconDelete" onClick={()=>removeImage(data)}/>
                            </div>
                          <img
                          className="imageThumb"
                            src={data.imgURl}
                            alt="imagem"
                            title="imagem"
                            width="100px"
                            height="100px"
                            style={{ margin: "5px" }}
                          /> 
                          </div>
                        );
                        
                    })}
                  </div>
                ) : null}
              </div>

              {/* ###==> submit button here...  */}
              <div
                style={{
                  display: "flex",
                  marginTop: 10,
                  backgroundColor: "#fefefe",
                  paddingLeft: 10,
                  paddingRight: 10,
                  paddingBottom: 30,

                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "#5f7b8a",
                    width: "40%",
                    fontSize: "20px",
                  }}
                  onClick={() => {
                    sentDateOfForm();
                  }}
                >
                  {!loading ? (
                    "أضافة"
                  ) : (
                    <div class="spinner-border " role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  )}
                </Button>
              </div>

              {/* snack alert box here ... */}
              <Snackbar
                open={snackBar.open}
                autoHideDuration={6000}
                onClose={() => {
                  setsnackBar({ ...snackBar, open: false });
                }}
                anchorOrigin={{
                  vertical: snackBar.vertical,
                  horizontal: snackBar.horizontal,
                }}
              >
                <Alert
                  onClose={() => {
                    setsnackBar({ ...snackBar, open: false });
                  }}
                  severity={snackBar.severity}
                  sx={{ width: "100%" }}
                >
                  {snackBar.message}
                </Alert>
              </Snackbar>
            </div>
          </div>

          {/* <SideMenu inactive={inactive} setInactiveFromProps={setInactive} /> */}
        </div>
      </div>
    </div>
  );
}
